import React from "react";
import "../../pages/contact-info/contact-info.css";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import MaskedTextField from "../../components/MaskedTextField";
import { Stack, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";


class PrimaryUserinfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: props?.data?.firstName,
      lastName: props?.data?.lastName,
      title: props?.data?.title,
      phoneNumber: props?.data?.phoneNumber,
      emailAddress: props?.data?.emailAddress,
      password: props?.data?.password,
      confirmPassword: props?.data?.confirmPassword,
      checkBoxStatus: props?.data?.checkBoxStatus,
    };
  }

  async handleCheckBoxStatus(e) {
    await this?.setState({ checkBoxStatus: e });
    this?.props?.setCheckBoxStatusError("");
  }
  async handleFirstName(e) {
    await this?.setState({ firstName: e });
    e == ""
      ? this?.props?.setFirstNameError("error")
      : this?.props?.setFirstNameError("");
  }
  async handleLastName(e) {
    await this?.setState({ lastName: e });
    e == ""
      ? this?.props?.setLastNameError("error")
      : this?.props?.setLastNameError("");
  }
  async handleTitle(e) {
    await this?.setState({ title: e });
    e == "" ? this?.props?.setTitleError("error") : this?.props?.setTitleError("");
  }
  async handlePhoneNumber(e) {
    await this?.setState({ phoneNumber: e });
    let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (e == "") {
      this?.props?.setPhoneNumberErrorPrimary("Please Enter Field");
    } else if (!regphone?.test(e)) {
      this?.props?.setPhoneNumberErrorPrimary("Format like (000) 000-0000");
    } else {
      this?.props?.setPhoneNumberErrorPrimary("");
    }
  }
  async handleEmailAddress(e) {
    await this?.setState({ emailAddress: e });
    // let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
      const regEmail = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/;

    if (e?.length === 0) {
      this?.props?.setEmailAddressError("Please enter email address");
    } else if (!regEmail?.test(e)) {
      this?.props?.setEmailAddressError("Invalid email address");
    } else {
      this?.props?.setEmailAddressError("");
    }
  }
  
  async handlePassword(e) {
    let errors = await this.validatePassword({
      NewPassword: e,
      ConfirmPassword: "",
    });
    await this?.setState({ password: e });
    Object.keys(errors)?.length > 0
      ? this?.props?.setPasswordError(errors?.NewPassword)
      : this?.props?.setPasswordError("");

    let errorsConfirmPassword = await this.validatePassword({
      NewPassword: this?.state?.password,
      ConfirmPassword: this?.state?.confirmPassword,
    });

    Object.keys(errorsConfirmPassword)?.length > 0
      ? this?.props?.setconfirmPasswordError(
        errorsConfirmPassword?.ConfirmPassword
      )
      : this?.props?.setconfirmPasswordError("");
  }
  async handleConfirmPassword(e) {
    let errors = await this.validatePassword({
      NewPassword: this?.state?.password,
      ConfirmPassword: e,
    });
    await this.setState({ confirmPassword: e });

    Object.keys(errors)?.length > 0
      ? this?.props?.setconfirmPasswordError(errors?.ConfirmPassword)
      : this?.props?.setconfirmPasswordError("");
  }

  async validatePassword(formData) {
    const errors = {};

    if (!formData?.NewPassword) {
      errors.NewPassword = "New password is required!";
    } else if (
      !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{10,}$/.test(
        formData?.NewPassword
      )
    ) {
      errors.NewPassword =
        "Minimum 10 characters, at least one uppercase letter, one lowercase letter, one number and one special character";
    }

    if (!formData?.ConfirmPassword) {
      errors.ConfirmPassword = "Confirm password is required!";
    } else if (formData?.ConfirmPassword !== formData?.NewPassword) {
      errors.ConfirmPassword = "Confirm password does not match!";
    }

    return errors;
  }

  render() {
    return (
      <>
        <div className="first-verify__registerationContainer">
          <div className="first-verify__inputContainer">
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.firstName}
                <span className="asterisk-red">*</span>
              </span>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                id="outlined-basic"
                error={this?.props?.firstNameErrorFlag}
                defaultValue={this?.props?.data?.firstName}
                onChange={(e) => this?.handleFirstName(e?.target?.value)}
                inputProps={{ className: "login-user" }}
                placeholder={
                  this?.props?.languageContent?.primaryUserInfo?.firstNameLabel
                }
                variant="outlined"
              />
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.lastName}
                <span className="asterisk-red">*</span>
              </span>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  height: 50,
                }}
                id="outlined-basic"
                error={this?.props?.lastNameErrorFlag}
                defaultValue={this?.props?.data?.lastName}
                onChange={(e) => this?.handleLastName(e?.target?.value)}
                inputProps={{ className: "login-user" }}
                placeholder={
                  this?.props?.languageContent?.primaryUserInfo?.lastNameLabel
                }
                variant="outlined"
              />
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.title}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6><div class='controlHintText'>Your title or position in your company. <h3>Examples</h3> Safety Manager <br /> Chief Operations Officer<br />Etc.</div></h6>
                  </div>
                }
                arrow
              >
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    height: 50,
                  }}
                  id="outlined-basic"
                  error={this?.props?.titleErrorFlag}
                  defaultValue={this?.props?.data?.title}
                  onChange={(e) => this?.handleTitle(e?.target?.value)}
                  inputProps={{ className: "login-user" }}
                  placeholder={
                    this?.props?.languageContent?.primaryUserInfo?.titleLabel
                  }
                  variant="outlined"
                />
              </Tooltip>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.phoneNumber}
                <span className="asterisk-red">*</span>
              </span>
              <MaskedTextField
                mask="(999) 999-9999"
                placeholder="(555) 000-0000"
                value={this?.state?.phoneNumber || ""}
                onChange={(e) => this?.handlePhoneNumber(e)}
                size="small"
                inputProps={{ className: "login-user" }}
                className="input-number-cstm-style"
              />
              <Typography className="text-danger mt-1" component={"span"}>
                {this?.props?.primayPhoneNumberErrorFlag}
              </Typography>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.emailAddress}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6>Please ensure you enter a valid email address. You will receive an account activation email at this address after you create your account.</h6>
                  </div>
                }
                arrow
              >
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    height: 50,
                  }}
                  id="outlined-basic"
                  error={this?.props?.emailAddressErrorFlag}
                  defaultValue={this?.props?.data?.emailAddress}
                  onChange={(e) => this?.handleEmailAddress(e?.target?.value)}
                  inputProps={{ className: "login-user" }}
                  placeholder={
                    this?.props?.languageContent?.primaryUserInfo?.emailAddressLabel
                  }
                  variant="outlined"
                  className="mb-2"
                />
              </Tooltip>
              <Typography className="text-danger mt-1" component={"span"}>
                {this?.props?.emailAddressErrorFlag}
              </Typography>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.password}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6><div class='controlHintText'>Your password must meet the following requirements:<br />At least 10 characters long<br />Contain at least 1 uppercase letter<br />Contain at least 1 lowercase letter<br />Contain at least 1 number <br />Contain at least 1 special character</div></h6>
                  </div>
                }
                arrow
              >
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    height: 50,
                  }}
                  id="outlined-basic"
                  error={this?.props?.passwordErrorFlag}
                  type={"password"}
                  defaultValue={this?.props?.data?.password}
                  onChange={(e) => this?.handlePassword(e?.target?.value)}
                  inputProps={{ className: "login-user" }}
                  placeholder={
                    this?.props?.languageContent?.primaryUserInfo?.passwordLabel
                  }
                  variant="outlined"
                  className="mb-2"
                />
              </Tooltip>
              <Typography className="text-danger mt-1" component={"span"}>
                {this?.props?.passwordErrorFlag}
              </Typography>
            </div>
            <div className="formControl-container">
              <span className="username-label">
                {this?.props?.languageContent?.primaryUser?.confirmPassword}
                <span className="asterisk-red">*</span>
              </span>
              <Tooltip
                placement="left-start"
                title={
                  <div >
                    <h6>Please re-type the password you entered in the Password box above.</h6>
                  </div>
                }
                arrow
              >
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    height: 50,
                  }}
                  id="outlined-basic"
                  error={this?.props?.confirmPasswordErrorFlag}
                  type={"password"}
                  defaultValue={this?.props?.data?.confirmPassword}
                  onChange={(e) => this?.handleConfirmPassword(e?.target?.value)}
                  inputProps={{ className: "login-user" }}
                  placeholder={
                    this?.props?.languageContent?.primaryUserInfo
                      ?.confirmPasswordLabel
                  }
                  variant="outlined"
                  className="mb-2"
                />
              </Tooltip>
              <Typography className="text-danger mt-2" component={"span"}>
                {this?.props?.confirmPasswordErrorFlag}
              </Typography>
            </div>
            <div className="user-agreement mx-2" style={{}}>
              <Stack direction={"row"}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={this?.props?.data?.checkBoxStatus} // Set defaultChecked based on checkBoxStatus
                        onChange={(event) =>
                          this?.handleCheckBoxStatus(event?.target?.checked)
                        } // Update checkBoxStatus on change
                      />
                    }
                    label={
                      <span style={{ fontSize: "14px" }}>
                        {this?.props?.languageContent?.primaryUserInfo?.termsLabel} <a href="/terms_and_conditions" target="blank" style={{ fontSize: "14px", color: "#2A93DB", textDecoration: "none" }} >
                          {this?.props?.languageContent?.primaryUserInfo?.termsLabe2}
                        </a>
                      </span>
                    }
                  />
                  <Typography className="text-danger mt-2" component={"span"}>
                    {this?.props?.checkBoxStatusError}
                  </Typography>
                </FormGroup>

              </Stack>
            </div>
            <div className="formControl-container">
              <Button
                variant="outlined"
                sx={{ marginTop: 1, textTransform: "capitalize" }}
                className="login-button-cancel-address"
                onClick={() =>
                  this?.props?.data?.setPrimaryUserInfoForm(
                    this?.state?.firstName?.trim(),
                    this?.state?.lastName?.trim(),
                    this?.state?.title?.trim(),
                    this?.state?.phoneNumber?.trim(),
                    this?.state?.emailAddress?.trim(),
                    this?.state?.password?.trim(),
                    this?.state?.confirmPassword?.trim(),
                    "back",
                    this?.state?.checkBoxStatus
                  )
                }
              >
                {this?.props?.languageContent?.primaryUser?.back}
              </Button>
              <Button
                variant="contained"
                className="login-button-address"
                sx={{ textTransform: "capitalize" }}
                onClick={() =>
                  this?.props?.data?.setPrimaryUserInfoForm(
                    this?.state?.firstName?.trim(),
                    this?.state?.lastName?.trim(),
                    this?.state?.title?.trim(),
                    this?.state?.phoneNumber?.trim(),
                    this?.state?.emailAddress?.trim(),
                    this?.state?.password?.trim(),
                    this?.state?.confirmPassword?.trim(),
                    "next",
                    this?.state?.checkBoxStatus
                  )
                }
                disabled={this?.props?.Dis}
              >
                {this?.props?.languageContent?.primaryUser?.createAccount}
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PrimaryUserinfo;